/* ============================================
   MATCHIBI THEME — main.js
   ============================================ */

(function() {
  'use strict';

  /* --- Scroll-based header shadow --- */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* --- Mobile menu toggle --- */
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.style.display === 'flex';
      mobileNav.style.display = isOpen ? 'none' : 'flex';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* --- Cart Drawer --- */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerClose = document.querySelector('.cart-drawer__close');
  const cartDrawerOverlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* Cart trigger buttons */
  document.addEventListener('click', (e) => {
    if (e.target.closest('.header-cart-btn')) openCartDrawer();
  });

  /* --- Cart API --- */
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    return res.json();
  }

  async function updateCartItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async function updateCartCount() {
    try {
      const cart = await getCart();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }

  async function refreshCartDrawer() {
    const body = document.getElementById('cart-drawer-body');
    if (!body) return;
    try {
      const cart = await getCart();
      if (cart.item_count === 0) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
        return;
      }
      body.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item__image">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
          <div>
            <div class="cart-item__title" style="font-family:'free-serif',serif;font-size:16px">${item.product_title}</div>
            <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div class="quantity-wrap" style="width:fit-content">
              <button class="quantity-btn" data-key="${item.key}" data-action="decrease">−</button>
              <input class="quantity-input" type="number" value="${item.quantity}" min="0" data-key="${item.key}" style="width:40px">
              <button class="quantity-btn" data-key="${item.key}" data-action="increase">+</button>
            </div>
          </div>
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
        </div>
      `).join('');

      /* subtotal */
      body.innerHTML += `
        <div style="margin-top:20px;padding-top:16px;border-top:1px solid var(--color-border);display:flex;justify-content:space-between;align-items:center;">
          <span style="font-family:var(--font-body);font-size:22px;color:var(--color-text-muted)">Subtotal</span>
          <span style="font-family:var(--font-body);font-size:22px;font-weight:700;color:var(--color-green-dark)">${formatMoney(cart.total_price)}</span>
        </div>
      `;

      /* quantity btn listeners */
      body.querySelectorAll('.quantity-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
          const key = btn.dataset.key;
          const input = body.querySelector(`.quantity-input[data-key="${key}"]`);
          let qty = parseInt(input.value);
          if (btn.dataset.action === 'increase') qty++;
          else qty = Math.max(0, qty - 1);
          await updateCartItem(key, qty);
          updateCartCount();
          refreshCartDrawer();
        });
      });
    } catch(e) {
      body.innerHTML = '<p class="cart-drawer__empty">Could not load cart.</p>';
    }
  }

  /* --- Add to Cart handler (product page & cards) --- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    // Prevent the native form submission — we're handling this via AJAX only.
    // Without this, clicking Add to Cart could trigger BOTH a full-page form
    // submit AND this fetch call at the same time, causing a race condition
    // where the item added via AJAX (always quantity 1, see below) could win
    // over the real submission that had the correct quantity.
    e.preventDefault();

    const variantId = btn.dataset.variantId || btn.closest('[data-variant-id]')?.dataset.variantId;
    if (!variantId) return;

    // Read the customer's actual selected quantity. Previously this was never
    // read at all, so addToCart() silently used its default of 1 every time,
    // regardless of what was shown in the quantity input on the page.
    const qtyInput = document.querySelector('.product-qty-input');
    const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

  try {
    await addToCart(variantId, quantity);
    updateCartCount();
    showToast('Added to cart!');
    openCartDrawer();
  } catch (e) {
    showToast('Could not add to cart.');
  }
  });

  /* --- Toast notification --- */
  let toastTimeout;
  function showToast(message) {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    clearTimeout(toastTimeout);
    toast.classList.add('show');
    toastTimeout = setTimeout(() => toast.classList.remove('show'), 3000);
  }

  /* --- Product gallery thumbnails --- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    const gallery = thumb.closest('.product-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const mainImg = gallery.querySelector('.product-gallery__main img');
    if (mainImg) mainImg.src = thumb.querySelector('img')?.src || mainImg.src;
  });

  /* --- Variant selection --- */
  document.addEventListener('click', (e) => {
    const variantBtn = e.target.closest('.variant-btn');
    if (!variantBtn) return;
    const group = variantBtn.closest('.variant-options');
    if (!group) return;
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    variantBtn.classList.add('active');
    /* update product form hidden input */
    const form = variantBtn.closest('form[action="/cart/add"]');
    if (form) {
      const input = form.querySelector('[name="id"]');
      if (input) input.value = variantBtn.dataset.variantId;
    }
  });

  /* --- Quantity controls on product page ---
     NOTE: this is now handled entirely by the script in product-template.liquid,
     which also keeps the hidden quantity field in sync for Add to Cart.
     Having a second handler here caused +/- to double-fire (skipping by 2). */

  /* --- Newsletter form --- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.newsletter-form');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('.newsletter-form__input');
    if (input?.value) {
      showToast('Thanks for subscribing!');
      input.value = '';
    }
  });

  /* --- Animate elements on scroll --- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .feature-card').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  /* --- Init --- */
  updateCartCount();

})();
